import { lazy } from 'react';

import { ClientOnly } from '#/containers/ClientOnly';
import { AdSection } from '#/types/Ads/AdSection';
import { getItem } from '#/utils/localStorage';
import { useAdType } from '#/zustand-stores/adStore';

import { BannerAdsBox } from './BannerAds.styled';

const adComponents = {
  GRAD_FAIRS: lazy(() =>
    import('#/components/Banners/GradFairsBanner').then((module) => ({
      default: module.GradFairsBanner,
    })),
  ),
  SALARY_SURVEY: lazy(() =>
    import('#/components/Banners/SalarySurveyBanner').then((module) => ({
      default: module.SalarySurveyBanner,
    })),
  ),
  RESUME_DB: lazy(() =>
    import('#/components/Banners/ResumeDatabaseBanner').then((module) => ({
      default: module.ResumeDatabaseBanner,
    })),
  ),
};

export function BannerAds() {
  const adType = useAdType(AdSection.BANNER);
  const CurrentAd = adType ? adComponents[adType] : null;

  if (getItem('enableBannerAds-2025-6')) {
    return (
      <BannerAdsBox qaId="ads-container">
        <ClientOnly>{CurrentAd ? <CurrentAd /> : null}</ClientOnly>
      </BannerAdsBox>
    );
  }

  return null;
}
